export default "__VITE_ASSET__BxW78r_S__"